// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"9a1a4873","442":"e349b029"}[chunkId] + ".chunk.js";
};